// SkeletonBacklog.js
import React from 'react';
import "./SkeletonBacklog.css";

const SkeletonBacklog = () => {
  return (
    <div className="skeleton-backlog">
      {/* Header simplifié */}
      <header className="backlog__header">
        <div className="backlog__header-content">
          <div className="skeleton-tabs">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="skeleton-tab"></div>
            ))}
          </div>
          <div className="skeleton-search"></div>
        </div>
      </header>

      {/* Table skeleton minimaliste */}
      <main className="backlog__main">
        <div className="backlog__table-container">
          <table className="backlog__table">
            <thead className="backlog__table-head">
              <tr className="backlog__table-head-row">
                {[...Array(7)].map((_, i) => (
                  <th key={i} className="backlog__table-th">
                    <div className="skeleton-header"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="backlog__table-body">
              {[...Array(6)].map((_, i) => (
                <tr key={i} className="backlog__table-row">
                  {[...Array(7)].map((_, j) => (
                    <td key={j} className="backlog__table-td">
                      <div className="skeleton-cell"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default SkeletonBacklog;